import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { FormProvider } from "react-hook-form";

import { AdminMenuLayout } from "../../../shared/components";
import { WrapperCardRecipesCategories } from "./styled";
import { useRecipesCategories } from "../hook";
import { selectModalRecipesCategories } from "../../../redux";
import { TableRecipesCategories } from "./TableRecipesCategories";
import { ModalRecipesCategories } from "../../../shared/components/ui/modals/ModalRecipesCategories";

export const RecipesCategories = () => {
  const modalRecipesCategories = useSelector(selectModalRecipesCategories);
  const {
    isUpdateRecipesCategory,
    formMethodsCreate,
    formMethodsUpdate,
    changeModalRecipesCategoriesState,
  } = useRecipesCategories();

  return (
    <AdminMenuLayout
      pageDescription="recipes-categories"
      title="recipes-categories"
    >
      <WrapperCardRecipesCategories>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={changeModalRecipesCategoriesState}
            >
              Agregar nueva categoría de receta
            </Button>
          </Col>
        </Row>
        <TableRecipesCategories />
        {modalRecipesCategories && isUpdateRecipesCategory && (
          <FormProvider {...formMethodsUpdate}>
            <ModalRecipesCategories />
          </FormProvider>
        )}
        {modalRecipesCategories && !isUpdateRecipesCategory && (
          <FormProvider {...formMethodsCreate}>
            <ModalRecipesCategories />
          </FormProvider>
        )}
      </WrapperCardRecipesCategories>
    </AdminMenuLayout>
  );
};
